/**
 * RMCC utility functions
 */
Drupal.rmcc.util = {

  /**
   * Get current viewport
   * @returns {{w: number, h: number}}
   */
  viewport() {
    return {
      w: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      h: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
  },

  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  scrollPosition() {
    return {
      x: self.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft,
      y: self.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
    };
  },

  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  disableScroll() {
    let $html = $('html');
    $html
      .data('scroll-position', this.scrollPosition())
      .css({
        overflow: 'hidden'
      });
    window.scrollTo(0, this.scrollPosition().y);
  },

  /**
   * Get current scroll position
   * @returns {{x: number, y: number}}
   */
  enableScroll() {
    $('html').removeAttr('style');
    if (typeof scrollPosition === 'object') {
      window.scrollTo(0, scrollPosition.y);
    }
  },

  /**
   * Create the given css rule in the document head
   *
   * This is handy to move inline styles into the head section
   * enhancing markup readability and devtools performance
   *
   * @param id
   * @param cssRule
   */
  style(id, cssRule) {
    // If style tag doesn't exist yet create it
    if (!$(`#${id}`, 'head').size()) {
      $('head').append(`<style id="${id}"></style>`);
    }

    // Append style
    $(`#${id}`, 'head').html(cssRule);
  },

  /**
   * Set equal height to given elements
   * @param container
   */
  equalheight(container){

    let currentTallest  = 0,
        currentRowStart = 0,
        currentDiv      = 0,
        rowDivs         = [],
        $el,
        topPosition     = 0;

    $(container).each(function () {

      $el = $(this);
      $($el).height('auto');
      topPosition = $el.position().top;

      if (currentRowStart != topPosition) {
        for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
          rowDivs[currentDiv].height(currentTallest);
        }
        rowDivs.length  = 0; // empty the array
        currentRowStart = topPosition;
        currentTallest  = $el.height();
        rowDivs.push($el);
      } else {
        rowDivs.push($el);
        currentTallest = (currentTallest < $el.height()) ? ($el.height()) : (currentTallest);
      }
      for (currentDiv = 0; currentDiv < rowDivs.length; currentDiv++) {
        rowDivs[currentDiv].height(currentTallest);
      }
    });
  }

};

